import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import sagaMiddlewareFactory from "redux-saga";
import { rootReducer } from "reducers";
import { rootSaga } from "sagas";
import { INITIAL_STATE } from "../reducers/initial-state";
import {
  getLocalStorageItem,
  getLocalStorageObject
} from "../utils/helper";
import { TOKEN, USER } from "../utils/constants";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

const getPersistedState = () => {
  try {
    const token = getLocalStorageItem(TOKEN);
    if (!token) {
      return undefined;
    }

    const storedUser = getLocalStorageObject(USER);

    return {
      auth: {
        ...INITIAL_STATE.auth,
        token,
        user: storedUser || INITIAL_STATE.auth.user
      }
    };
  } catch (error) {
    console.warn("[store] failed to load persisted auth state", error);
    return undefined;
  }
};

export function configureStore(preloadedState = {}) {
  const sagaMiddleware = sagaMiddlewareFactory();
  const composedEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const enhancers = composedEnhancers(
    applyMiddleware(routerMiddleware(history), sagaMiddleware)
  );

  const initialState = {
    ...getPersistedState(),
    ...preloadedState
  };

  const store = createStore(rootReducer(history), initialState, enhancers);

  sagaMiddleware.run(rootSaga);

  return { store };
}
